import _ from "lodash";

const getPracticesIds = ({ practices }) => {
  return _.map(practices, ({ id }) => id);
};

export const getPracticesIdsMemoized = _.memoize(
  getPracticesIds,
  ({ practices }) => {
    return JSON.stringify({
      practices: _.map(practices, practice => _.pick(practice, ["id"])),
    });
  }
);
